module.exports = __webpack_public_path__ + "img/kochav_no.b7b412a5.png";